import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'luci-tooltips',
  templateUrl: './luci-tooltips.component.html',
  styleUrls: ['./luci-tooltips.component.scss']
})
export class LuciTooltipsComponent implements OnInit {

  @Input() tooltipPosition = '';
  @Input() message = '';
  @Input() icon = '';
  @Input() triggerOnOver = true;
  @Input() isTemplate = false;

  @Input() showTooltip = false;

  constructor() { }

  ngOnInit(): void {
  }

  getIcon() {
    return `assets/icons/luci.svg#${this.icon}`;
  }

}
